module.exports = __webpack_public_path__ + "static/datatable-format-do-8e54fe8ba02c2bcc885df079b93c237e.png";